import { PaymentAttempt } from '../models/entities/payment-attempt';
import { PaymentItem } from '../models/entities/payment-item';
import { Transaction } from '../models/entities/transactions/transaction';

/**
 * Determines the display amount for a child transaction in deposit/payment contexts.
 * Returns a negative value for inflows (renders green via legfiBalance pipe)
 * and a positive value for outflows like returns/disputes (renders black).
 *
 * Outflow detection signals:
 * - Description starts with 'returned' or 'disputed'
 * - Amount is already negative in DB
 * - Transaction is soft-deleted (deletedAt set)
 * - PaymentAttempt reference has returned flag
 */
export function getChildDisplayAmount(child: Transaction): number {
    const description = (child.description || '').toLowerCase();
    const isOutflow = description.startsWith('returned') ||
                      description.startsWith('disputed') ||
                      child.amount < 0 ||
                      !!child.deletedAt ||
                      (child.reference && 'returned' in child.reference && (child.reference as PaymentAttempt).returned);

    return isOutflow ? Math.abs(child.amount) : -Math.abs(child.amount);
}

/**
 * Determines the display amount for a payment item.
 * Returns a negative value for normal payments (renders green via legfiBalance pipe)
 * and a positive value for returned items (renders black).
 */
export function getPaymentItemDisplayAmount(item: PaymentItem): number {
    const isReturned = !!item.deletedAt;
    return isReturned ? Math.abs(item.amount) : -Math.abs(item.amount);
}
